import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { FaqInterface } from '../interfaces/faq.interface';
import { FaqCategoryInterface } from '../interfaces/faq-category.interface';
import { PaginatedFaqListResponseInterface } from '../interfaces/paginated-faq-list-response.interface';
import { FaqSurveyAnswerEnum } from '../enums/faq-survey-answer.enum';
import { originWithContext } from '../utils/origin-with-context.util';
import { APP_ROUTES } from '../constants/app-routes.constant';
import { ENDPOINTS } from '../constants/endpoints.constant';
import { DEFAULT_CATEGORIES, MOST_FREQUENT_FAQ_CATEGORY_ID } from '../constants/default-categories.constant';

@Injectable()
export class FaqService {
  constructor(private ajaxService: AjaxService) {}

  private getFaqListWithUrls(faqList: FaqInterface[]): FaqInterface[] {
    const faqListWithUrls = faqList.map((item) => {
      const url = `${originWithContext()}${APP_ROUTES.helpCenter.children.faq.url}/${item.id}`;

      return {
        ...item,
        url
      };
    });

    return faqListWithUrls;
  }

  public async getAllFaqList() {
    const body = {
      todas: true,
      paginacao: 1,
      tamanhoPagina: 999
    };

    const response = await this.ajaxService.post<PaginatedFaqListResponseInterface>(ENDPOINTS.allFaqList.url, body);

    const allFaqList = this.getFaqListWithUrls(response.perguntaFrequenteResponse);

    return allFaqList;
  }

  public async getMostFrequentFaqList() {
    let mostFrequentFaqList = await this.ajaxService.get<FaqInterface[]>(ENDPOINTS.mostFrequentFaqList.url);

    mostFrequentFaqList = this.getFaqListWithUrls(mostFrequentFaqList);

    mostFrequentFaqList = mostFrequentFaqList.map((item) => {
      return {
        ...item,
        idCategoria: MOST_FREQUENT_FAQ_CATEGORY_ID
      };
    });

    return mostFrequentFaqList;
  }

  public async getFaqById(faqId: number) {
    const allFaqList = await this.getAllFaqList();

    const faq = allFaqList.find((item) => item.id === faqId);

    return faq;
  }

  public registerFaqAccess(faqId: number) {
    return this.ajaxService.post<null>(`${ENDPOINTS.registerFaqAccess.url}/${faqId}`);
  }

  public rateFaq(faqId: number, faqSurveyAnswer: FaqSurveyAnswerEnum) {
    const body = {
      avaliacao: faqSurveyAnswer,
      perguntaFrequenteID: faqId
    };

    return this.ajaxService.post<number>(ENDPOINTS.rateFaq.url, body);
  }

  public updateFaqRating(faqId: number, faqSurveyAnswer: FaqSurveyAnswerEnum, faqRatingId: number, reason: string) {
    const body = {
      avaliacao: faqSurveyAnswer,
      perguntaFrequenteID: faqId,
      perguntaFrequenteAvaliacaoID: faqRatingId,
      motivo: reason
    };

    return this.ajaxService.post<number>(ENDPOINTS.rateFaq.url, body);
  }

  public async getFaqCategoryList() {
    const list = await this.ajaxService.get<FaqCategoryInterface[]>(ENDPOINTS.faqCategoryList.url);

    const sortedList = [...list].sort((a, b) => a.nome.localeCompare(b.nome));

    const fullList = [...DEFAULT_CATEGORIES, ...sortedList];

    return fullList;
  }


  public getFaqCategoryLink(id :  number): string {
    return `${originWithContext()}${APP_ROUTES.helpCenter.children.categoria.url}/${id}`;
  }

}
